import { STATUS_LABEL, type TarpRecordStatus } from '@/domain/tarp/status';

const TONE: Record<TarpRecordStatus, string> = {
  // rascunho — tom neutro + tracejado sinaliza "ainda não é oficial"
  EM_ABERTURA: 'bg-slate-500/15 text-slate-300 border-slate-400/50 border-dashed',
  ABERTA: 'bg-level-alerta/15 text-level-alerta border-level-alerta/40',
  EM_ANALISE_RT: 'bg-jf-yellow/15 text-jf-yellow border-jf-yellow/40',
  CONCLUIDA_AGUARDANDO: 'bg-sky-500/15 text-sky-300 border-sky-500/40',
  ENCERRADA: 'bg-level-normal/15 text-level-normal border-level-normal/40',
};

/** Pill de status do TARP (v5.10). */
export function TarpStatusPill({ status }: { status: TarpRecordStatus }) {
  return (
    <span
      className={`shrink-0 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full border ${TONE[status]}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
